import request, { convertData, format } from '@shared/innmaxLib/services'
import toQueryString from '@shared/innmaxLib/utils/toQueryString'
import React from 'react'
import { useQuery, UseQueryOptions } from 'react-query'
import { useNotificationConverter } from './notification.convert'
import { INotification } from './notification.type'

export const useChargeEventNotification = (
  query?: any,
  options?: UseQueryOptions & { displayError?: boolean }
) => {
  const converter = useNotificationConverter()

  const { fullUrl, params } = format(
    '/notification/{pageNum}/{pageSize}',
    query
  )

  const { displayError = true, ...otherOptions } = options || {}

  const { data: _data, ...others } = useQuery(
    ['notification/{pageNum}/{pageSize}', query],
    () =>
      request(`${fullUrl}?${toQueryString(params)}`, {
        method: 'GET',
        displayError,
      }),
    {
      ...otherOptions,
    }
  )

  const dataSource = React.useMemo(() => {
    return convertData<INotification>({
      field: ['data'],
      converter,
    })(_data)
  }, [_data, converter])

  return {
    ...others,
    dataSource,
    loading: others.isLoading,
  }
}
